import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaCog, FaUser, FaSignOutAlt, FaBars } from 'react-icons/fa';
import { useAuth } from '../context/AuthContext';
import { getProfilePicture, getUploadUrl } from '../utils/helpers';

const Header = ({ title = '', showMenu = true, showUserMenu = true }) => {
  const { user, logout, refreshUser } = useAuth();
  const navigate = useNavigate();
  const [showUserDropdown, setShowUserDropdown] = useState(false);


  const handleLogout = async () => {
    await logout(() => navigate('/?login'));
  };

  return (
    <header className="matchus-encounters-header" style={{ height: '60px' }}>
      <div className="matchus-header-container" style={{ height: '60px' }}>
        <div className="matchus-header-left">
          <Link to="/encounters" className="matchus-logo">
            <img src="/assets/images/logo-matchus.svg" alt="MatchUs" className="h-6 w-6 mr-2" />
            <span className="matchus-brand-name">Match Us</span>
          </Link>
        </div>

        {title && (
          <div className="matchus-header-center">
            <h1 className="matchus-page-title">{title}</h1>
          </div>
        )}

        <div className="matchus-header-right">
          {showUserMenu && user && (
            <div className="matchus-user-menu">
              <button
                className="matchus-user-btn"
                onClick={() => setShowUserDropdown(!showUserDropdown)}
              >
                <img
                  src={user?.profile_photo ? getUploadUrl(`user-${user.id}/${user.profile_photo}`) : getProfilePicture(user || { id: 1 })}
                  alt="Profile"
                  className="matchus-user-avatar"
                />
                <span className="matchus-user-name">{user?.full_name?.split(' ')[0] || 'You'}</span>
              </button>

              <div className={`matchus-user-dropdown ${showUserDropdown ? 'show' : ''}`}>
                <Link to="/settings" className="matchus-dropdown-item" onClick={() => setShowUserDropdown(false)}>
                  <FaCog />
                  <span>Settings</span>
                </Link>
                  <Link to={`/user/${user?.id}`} className="matchus-dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    <FaUser />
                    <span>Profile</span>
                  </Link>
                  <div className="matchus-dropdown-divider"></div>
                {(user?.is_admin === 1 || user?.role?.name === 'admin' || user?.role?.name === 'moderator') && (
                  <Link to="/admin" className="matchus-dropdown-item" onClick={() => setShowUserDropdown(false)}>
                    <FaCog />
                    <span>Admin Panel</span>
                  </Link>
                )}
                <button
                  type="button"
                  className="matchus-dropdown-logout"
                  onClick={() => {
                    setShowUserDropdown(false);
                    handleLogout();
                  }}
                >
                  <FaSignOutAlt />
                  <span>Logout</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Overlay to close dropdown */}
      {showUserDropdown && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setShowUserDropdown(false)}
        />
      )}
    </header>
  );
};

export default Header;